/**
 * Client-side fallback redirects for legacy Wix URLs.
 *
 * Primary mechanism is the `public/_redirects` file (server-side 301).
 * These routes are a safety net for hosts that don't honour _redirects:
 * the user lands on the page, React swaps the URL via Navigate (replace),
 * and Google's crawler interprets it as a soft redirect.
 *
 * Stored as data so a single Routes file can mount them all.
 */

export const WIX_REDIRECTS = [
  // Legal pages
  { from: '/cadre-légal', to: '/mentions-legales' },
  { from: '/condition-générale-des-ventes', to: '/cgv' },
  { from: '/politique', to: '/politique-confidentialite' },

  // Services
  { from: '/alloréparations', to: '/#services' },
  { from: '/allosmartphones', to: '/#services' },
  { from: '/services-1', to: '/#services' },
  { from: '/services-5', to: '/#services' },
  { from: '/services-6', to: '/#services' },
  { from: '/formulaire-de-formation', to: '/#services' },

  // Boutique / produits
  { from: '/alloaccessoires', to: '/#produits' },
  { from: '/copie-de-alloaccessoires', to: '/#produits' },
  { from: '/shop', to: '/#produits' },
  { from: '/copie-de-coques', to: '/#produits' },
  { from: '/copie-de-verres-trempés-1', to: '/#produits' },
  { from: '/copie-de-verres-trempés-2', to: '/#produits' },
  { from: '/copie-de-verres-trempés-3', to: '/#produits' },
  { from: '/copie-de-accessoires-autres', to: '/#produits' },

  // Contact / RDV
  { from: '/allonous', to: '/#contact' },
  { from: '/contact-3', to: '/#contact' },
  { from: '/book-online', to: '/#devis' },
  { from: '/livraison-boutique', to: '/#contact' },

  // FAQ
  { from: '/faq', to: '/#faq' },

  // Wix-generated duplicates → home
  { from: '/about-3', to: '/' },
  { from: '/about-3-2', to: '/' },
  { from: '/about-3-3', to: '/' },
  { from: '/about-3-4', to: '/' },
  { from: '/about-3-5', to: '/' },
  { from: '/about-5', to: '/' },
  { from: '/general-1', to: '/' },
  { from: '/general-5', to: '/' },
  { from: '/general-5-2', to: '/' },
];
